import type { Movement } from "./types";

export function isPendingMovement(movement: Movement): boolean {
  return movement.cardPaymentStatus !== "paid" && Math.max(0, movement.pendingAmountCents ?? 0) > 0;
}

/**
 * Las compras pendientes muestran el total facturado, como en el dashboard
 * original. Un registro heredado nunca debe aparecer como una compra de $0.00
 * cuando Firebase sí conserva su total bruto.
 */
export function movementDisplayAmountCents(movement: Movement): number {
  const billed = Math.max(0, movement.billedAmountCents ?? movement.amountCents);
  if (isPendingMovement(movement) || movement.amountCents <= 0) return billed;
  return movement.amountCents;
}
